class MWF_BooksList {
    constructor () {
        this.initEvents();
    }

    initEvents () {
        this.search = $('.books-search-form');
        this.listWrapper = $('.books-list');
        this.loadMore = $('.books-list-load-more'); 

        if (!(this.listWrapper.length && this.search.length)) {
            return;
        }

        this.items = this.listWrapper.find('.books-list-items .books-list-item');
        this.fixSearchAttributes();
        let input = this.search.find('.custom-search-input');

        this.displayedBooks = 10;
        this.availableBooks = this.items.length;
        this.filteredItems = null;

        input.on('keyup', () => { 
            this.filterBooks(input.val()); 
        });

        this.filterBooks(input.val());

        this.loadMore.on('click', e => {
            e.preventDefault();
            this.loadMoreBooks();
        });
    }

    fixSearchAttributes () {
        this.items.each((i, item) => {
            let searchPhrase = $(item).attr('data-title').replace(/&nbsp;/gmi, ' ').replace(/\s/gmi, ' ').toLocaleLowerCase();
            $(item).attr('data-title', searchPhrase);
        });
    }

    filterBooks (searchPhrase) {
        if (searchPhrase.trim() === '') {
            this.filteredItems = this.items;
            this.limitDisplayedBooks();
            return;    
        }

        let selector = '[data-title*="' + searchPhrase.replace(/\s/gmi, ' ').toLocaleLowerCase() + '"]';
        this.filteredItems = this.items.filter(selector);
        this.limitDisplayedBooks();

        if (this.filteredItems.length) {
            $('.books-list-items-empty-state').addClass('is-hidden');
        } else {
            $('.books-list-items-empty-state').removeClass('is-hidden');
        }
    }

    limitDisplayedBooks () {
        this.items.addClass('is-hidden');
        this.displayedBooks = 10;
        this.availableBooks = this.filteredItems.length;

        if (this.availableBooks > this.displayedBooks) {
            for (let i = 0; i < 10; i++) {
                this.filteredItems.eq(i).removeClass('is-hidden');
            }

            this.loadMore.removeClass('is-hidden');
        } else {
            this.filteredItems.removeClass('is-hidden');
            this.loadMore.addClass('is-hidden');
        }
    }

    loadMoreBooks () {
        let start = this.displayedBooks;
        this.displayedBooks += 10;

        for (let i = start; i < this.displayedBooks; i++) {
            if (i > this.availableBooks) {
                break;
            }

            this.filteredItems.eq(i).removeClass('is-hidden');
        }

        if (this.displayedBooks >= this.availableBooks) {
            this.loadMore.addClass('is-hidden');
        }
    }
}